import { PREFIX } from '~constants/fullstory';

export const BILLING_EVENTS = {
	VIEWED: `${PREFIX} Billing Viewed`,
	ASSIGN_PAYMENTS_VIEWED: `${PREFIX} Billing Assign Payments Viewed`,
	PAYMENT_METHOD_ASSIGNED: `${PREFIX} Payment Method Assigned`,
	PAYMENT_METHOD_ADD_STARTED: `${PREFIX} Payment Method Add Started`,
	PAYMENT_METHOD_ADDED: `${PREFIX} Payment Method Added`,
	PAYMENT_METHOD_ADD_FAILED: `${PREFIX} Payment Method Add Failed`,
	PAYMENT_METHOD_VERIFICATION_UNAVAILABLE: `${PREFIX} Payment Method Verification Unavailable`,
	PAYMENT_METHOD_DELETE_REQUESTED: `${PREFIX} Payment Method Delete Requested`,
	PAYMENT_METHOD_DELETED: `${PREFIX} Payment Method Deleted`,
	PAYMENT_METHOD_UPDATE_STARTED: `${PREFIX} Payment Method Update Started`,
	INVOICE_PDF_OPENED: `${PREFIX} Billing Invoice PDF Opened`,
	PAST_INVOICES_TOGGLED: `${PREFIX} Billing Past Invoices Toggled`,
	RECOVERY_BANNER_REVIEWED: `${PREFIX} Billing Recovery Banner Reviewed`,
	PAYMENT_METHODS_BANNER_CLICKED: `${PREFIX} Billing Payment Methods Banner Clicked`,
	HELP_CENTER_LINK_CLICKED: `${PREFIX} Billing Help Center Link Clicked`,
	TAB_SELECTED: `${PREFIX} Billing Tab Selected`,
	BILLING_ACCOUNT_TOGGLED: `${PREFIX} Billing Account Toggled`,
	DEFAULT_PAYMENT_METHOD_CHANGE_STARTED: `${PREFIX} Default Payment Method Change Started`,
	DEFAULT_PAYMENT_METHOD_CHANGED: `${PREFIX} Default Payment Method Changed`,
	DEFAULT_PAYMENT_METHOD_CHANGE_FAILED: `${PREFIX} Default Payment Method Change Failed`,
	DELINQUENCY_BANNER_CLICKED: `${PREFIX} Delinquency Banner Clicked`,
	DELINQUENCY_MODAL_VIEWED: `${PREFIX} Delinquency Modal Viewed`,
	DELINQUENCY_MODAL_CLICKED: `${PREFIX} Delinquency Modal Clicked`,
	DELINQUENCY_MODAL_DISMISSED: `${PREFIX} Delinquency Modal Dismissed`,
	DELINQUENCY_ACCESS_BLOCKED_MODAL_VIEWED: `${PREFIX} Delinquency Access Blocked Modal Viewed`,
	DELINQUENCY_ACCESS_BLOCKED_LOGOUT_CLICKED: `${PREFIX} Delinquency Access Blocked Logout Clicked`,
	// Separate from the working controls' events so locked clicks don't count as visits.
	DELINQUENCY_LOCKED_NAV_CLICKED: `${PREFIX} Delinquency Locked Nav Clicked`,
};
